import React, {Component, Fragment} from 'react';
import Profile from '../users/Profile';
import axios from 'axios';
import {passCsrfToken, toTableData} from '../../helpers';
import PartnerProfile from '../partners/PartnerProfile';
import history from '../../history';
import {getAdminVendor, confirmPartner, deleteAdminPartner, activatePartner, deactivatePartner, restoreAdminPartner} from '../../api/partnerApi';
import VendorListingsTabs, { assignmentTypesLabel } from './VendorListingsTabs';

class PartnerDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			partner: {}
		};
	}

	componentDidMount() {
		passCsrfToken(document, axios);
		this.fetchPartner();
	}

	fetchPartner = () => {
		const id = this.props.match.params.id;
		getAdminVendor(id).then((response) => {
			this.setState({ partner: response.data || {} });
		}).catch(() => {
			this.setState({ partner: {} });
		});
	};

	callPartnerConfirm(id) {
		confirmPartner(id)
			.then((response) => {
				swal({
					title: 'Partner Approval Request!',
					text: 'partnership request is approved and email sent to partners',
					icon: 'success',
					button: 'Continue!'
				});
				history.goBack();
			})
			.catch((error) => {
				console.log(' partner request approval error', error);
			});
	}

	callPartnerActivate(id) {
		activatePartner(id)
			.then((response) => {
				swal({
					title: 'Partner Activation Request!',
					text: 'partnership is activated',
					icon: 'success',
					button: 'Continue!'
				});
				history.goBack();
			})
			.catch((error) => {
				console.log(' partner Activation error', error);
			});
	}

	callPartnerDeactivate(id) {
		deactivatePartner(id)
			.then((response) => {
				swal({
					title: 'Partner deactivation Request!',
					text: 'partnership is deactivated',
					icon: 'success',
					button: 'Continue!'
				});
				history.goBack();
			})
			.catch((error) => {
				console.log(' partner deactivate error', error);
			});
	}

	callPartnerRestore(id) {
		restoreAdminPartner(id)
			.then(() => {
				swal({
					title: 'Vendor restored',
					text: 'This vendor is active again and can log in.',
					icon: 'success',
					button: 'Continue!'
				});
				this.fetchPartner();
			})
			.catch((error) => {
				const msg = (error.response?.data?.errors || [])?.join(' ') || 'Restore failed';
				swal('Error', msg, 'error');
			});
	}

	destroyPartner(id) {
		// deletePartner(id)
		// .then((response) => {
		// 	swal({
		// 		title: 'Partner deleted!',
		// 		text: `this partner is deleted`,
		// 		icon: 'success',
		// 		button: 'Continue!'
		// 	});
		// 	history.push('/admin/partners');

		// })
		// .catch((error) => {
		// 	swal({
		// 		title: 'Partner Delete error',
		// 		text: 'Something went wrong. please try again or contact us',
		// 		icon: 'error',
		// 		button: 'Continue!'
		// 	});
		// })

		swal({
			title: 'Are you sure?',
			text: 'Once deleted, this vendor will be soft-deleted. You can restore them later from Status → Deleted.',
			icon: 'warning',
			buttons: true,
			dangerMode: true
		}).then((willDelete) => {
			if (willDelete) {
				deleteAdminPartner(id).then(() => {
					swal('Vendor deleted', { icon: 'success' });
					history.push('/admin/partners');
				});
			}
		});
	}

	render() {
		const {partner} = this.state;
		const vendorId = partner.idx || partner.id;
		return (
			<Fragment>
				<div className="mb-3">
					<h4 className="mb-0">Vendor detail</h4>
					{partner.company_name && <p className="mb-1"><strong>Company:</strong> {partner.company_name}</p>}
					{partner.first_name != null && <p className="mb-1"><strong>Name:</strong> {[partner.first_name, partner.last_name].filter(Boolean).join(' ')}</p>}
					<p className="text-muted small mb-0">Services: {assignmentTypesLabel(partner)}</p>
					{partner.listing_pending && (
						<p className="mb-0">
							<span className="text-danger font-weight-bold">Pending listings:</span> G{partner.listing_pending.group_tours || 0} · S{partner.listing_pending.shared_rentals || 0} · P{partner.listing_pending.packages || 0}
						</p>
					)}
				</div>
				<PartnerProfile partner={this.state.partner} allowEdit />

				{vendorId && (
					<VendorListingsTabs vendorId={vendorId} partner={partner} onRefresh={this.fetchPartner} />
				)}

				<div className='text-center'>
					{partner.is_deleted && (
						<span className='btn btn-success' onClick={() => this.callPartnerRestore(vendorId)}>
							Restore
						</span>
					)}
					{!partner.is_deleted && partner.status === 'approved' && (
						<span className='btn btn-secondary' onClick={() => this.callPartnerDeactivate(partner.idx)}>
							deactivate
						</span>
					)}
					{!partner.is_deleted && partner.status === 'inactive' && (
						<span className='btn btn-secondary' onClick={() => this.callPartnerActivate(partner.idx)}>
							activate
						</span>
					)}
					{!partner.is_deleted && partner.status === 'processing' && (
						<span className='btn btn-secondary' onClick={() => this.callPartnerConfirm(partner.idx)}>
							Confirm
						</span>
					)}
					{!partner.is_deleted && (
						<span className='btn btn-danger ml-2' onClick={() => this.destroyPartner(partner.idx)}>
							Delete
						</span>
					)}
				</div>
			</Fragment>
		);
	}
}
export default PartnerDetails;
